<template>
  <div>
    <div :class="overlay ? `homepage-hero-content-overlay-wrapper homepage-video-content-overlay-wrapper-${sectionId} ${!showOverlay ? 'overlay-hidden' : ''}` : ''">
      <div
        v-if="showOverlay && !hero && !autoplay"
        class="video--video__static-image"
      >
        <!-- Image filled using CSS background-image -->
      </div>

      <div
        v-if="showOverlay && !hero && !autoplay"
        class="video--video__text-block"
        v-on:click="play"
        v-on:keyup.enter="play"
      >
        <button class="round-icon-btn-lg color-scheme-btn btn-hover-default icon-btn-focus">
          <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20"><path d="M5.755 3.78085C5.67909 3.73584 5.59262 3.71173 5.50437 3.71096C5.41612 3.71019 5.32924 3.73279 5.25255 3.77646C5.17586 3.82014 5.1121 3.88333 5.06775 3.95963C5.02339 4.03592 5.00002 4.1226 5 4.21085V15.7892C5.00002 15.8774 5.02339 15.9641 5.06775 16.0404C5.1121 16.1167 5.17586 16.1799 5.25255 16.2236C5.32924 16.2672 5.41612 16.2898 5.50437 16.2891C5.59262 16.2883 5.67909 16.2642 5.755 16.2192L15.5242 10.43C15.5988 10.3857 15.6606 10.3228 15.7035 10.2474C15.7464 10.172 15.769 10.0868 15.769 10C15.769 9.91326 15.7464 9.828 15.7035 9.7526C15.6606 9.67721 15.5988 9.61429 15.5242 9.57002L5.755 3.78085Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
      </div>

      <div :class="{ 'embed-container': !hero, 'type-youtube' : videoType === 'youtube' && !hero }">
        <div ref="video" class="video">
          <video
            v-if="videoType === 'mp4'"
            ref="videoMP4"
            class="hero-video-mp4" playsinline controls
          >
            <source v-bind:src="url" type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Youtube from '../global/Youtube';
import Vimeo from '../global/Vimeo';
import MP4Video from '../global/MP4Video';
import ThemeBase from '../ThemeBase';

export default Vue.extend({
  props: {
    theme: ThemeBase,
    hero: Boolean,
    videoType: {
      type: String,
      required: true,
      validator: function (value) {
        return ['youtube', 'vimeo', 'mp4'].indexOf(value) !== -1
      },
    },
    url: {
      type: String,
      required: true,
    },
    autoplay: {
      type: Boolean,
      required: true,
    },
    loop: Boolean,
    mute: Boolean,
    hideControls: {
      type: Boolean,
      default: false,
    },
    overlayOpacity: {
      type: Number,
      default: 1,
    },
    sectionId: {
      type: String,
      default: '',
    },
    overlay: Boolean,
  },
  data() {
    return {
      /** @type {import('../global/VideoBase').default} */
      player: null,
      isPlaying: false,
      showOverlay: true
    };
  },
  mounted() {
    if (this.videoType === 'youtube') {
      this.player = new Youtube(this.$root.theme, this.$refs.video);
    } else if (this.videoType === 'vimeo') {
      this.player = new Vimeo(this.$root.theme, this.$refs.video);
    } else if (this.videoType === 'mp4') {
      this.player = new MP4Video(this.$root.theme, this.$refs.videoMP4);
    }
    this.player.init({
      autoplay: this.autoplay,
      hideControls: this.hideControls,
      url: this.url,
      mute: this.mute,
      loop: this.loop,
      onPlay: this.onPlay,
      onPause: this.onPause,
      onEnd: this.onEnd,
    });
  },
  methods: {
    onPlay() {
      this.isPlaying = true;
    },
    onPause() {
      this.isPlaying = false;
    },
    onEnd() {
      this.isPlaying = false;
    },
    play() {
      this.player.play();
      this.showOverlay = false;
    }
  }
})
</script>
